// Types
import mixins from "vue-typed-mixins";
// Mixins
import ControllerBase from '../../mixins/ControllerBase';
import Consentable from '../../mixins/Consentable';
import VuelidateHelper from '../../mixins/VuelidateHelper';

// Enums
import { FormWithConsent } from '../../enums/Gdpr';

// Utils
import { email, requiredIf } from 'vuelidate/lib/validators';
import { forEachKey } from '../../utils/hasKey';
const ControllerContactForm = mixins(ControllerBase, Consentable(FormWithConsent.Contact), VuelidateHelper).extend({
  name: 'ControllerContactForm',
  props: {
    requiredFields: {
      type: Array,
      default() {
        return [];
      }
    },
    additionalFields: {
      type: Array,
      default() {
        return [];
      }
    },
    subject: {
      type: String,
      default: ''
    },
    hideSuccessNotification: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const form = {
      firstName: '',
      lastName: '',
      contactNumber: '',
      from: '',
      content: '',
      subject: this.subject
    };
    if (this.additionalFields.length) {
      const additionalFields = {};
      this.additionalFields.forEach(key => {
        additionalFields[key] = '';
      });
      form.additionalFields = additionalFields;
    }
    return {
      form
    };
  },
  validations() {
    const isFieldRequired = fieldKey => this.requiredFields.includes(fieldKey);
    const validations = {
      form: {
        firstName: {
          required: requiredIf(() => isFieldRequired('firstName'))
        },
        lastName: {
          required: requiredIf(() => isFieldRequired('lastName'))
        },
        contactNumber: {
          required: requiredIf(() => isFieldRequired('contactNumber'))
        },
        from: {
          required: requiredIf(() => isFieldRequired('from')),
          email
        },
        content: {
          required: requiredIf(() => isFieldRequired('content'))
        },
        subject: {
          required: requiredIf(() => isFieldRequired('subject'))
        }
      }
    };
    const {
      additionalFields
    } = this.form;
    if (additionalFields && Object.keys(additionalFields).length) {
      validations.form.additionalFields = {};
      forEachKey(additionalFields, key => {
        ;
        validations.form.additionalFields[key] = {
          required: requiredIf(() => isFieldRequired(key))
        };
      });
    }
    return validations;
  },
  computed: {
    contactRequestObject() {
      if (!this.form.additionalFields) {
        return this.form;
      }
      const convertedContact = {
        ...this.form,
        additionalFields: []
      };
      const {
        additionalFields
      } = this.form;
      forEachKey(additionalFields, key => {
        convertedContact.additionalFields.push({
          key,
          value: additionalFields[key]
        });
      });
      return convertedContact;
    }
  },
  methods: {
    /**
     * Check consent requirements, validate form inputs and submit contact form if they are passed
     */
    async submit() {
      const isRecaptchaInitialized = ('grecaptcha' in window);
      if (!isRecaptchaInitialized) {
        throw new Error(this.$t('error.recaptchaMissing'));
      }
      this.$v.form.$touch();
      const consentsValid = await this.validateConsents(this.form.from);
      if (this.$v.form.$invalid || !consentsValid) return;
      const recaptchaToken = await this.$recaptcha.getResponse();
      const req = this.$api.cms.contact.contactAdmin({
        ...this.contactRequestObject,
        recaptchaToken
      });
      const res = await this.callWithStatusUpdate(req, 'submitted');
      this.$recaptcha.reset();
      if (res.errored) return;
      if (!this.hideSuccessNotification) {
        this.$toast.success(this.$t('core.notifications.contactFormSubmitted'));
      }
    }
  },
  render() {
    const {
      form,
      assignedConsents: consents,
      submit,
      $v,
      status,
      generateErrorMessage
    } = this;
    const slotProps = {
      form,
      consents,
      submit,
      $v,
      status,
      generateErrorMessage
    };
    return this.renderContainer(slotProps);
  }
});
export default ControllerContactForm;